/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyForgePioStackOverflowIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-pio-stack-overflow-prod" */ './utils').then(
			(m) => m.ForgePioStackOverflowIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-pio-stack-overflow-prod/icon' },
);

const LazyForgePioStackOverflowSearchResultIconComponent = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "icon-forge-pio-stack-overflow-prod-search-result" */ './utils'
		).then((m) => m.ForgePioStackOverflowSearchResultIcon),
	{
		moduleId: '@atlassian/rovo-connectors-config/forge-pio-stack-overflow-prod/search-result-icon',
	},
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const ForgePioStackOverflowIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgePioStackOverflowIconComponent />
	</Suspense>
);

export const ForgePioStackOverflowSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgePioStackOverflowSearchResultIconComponent />
	</Suspense>
);
